// extracted by mini-css-extract-plugin
export default {"confirmation":"ConfirmationPage_confirmation__dqDPP","fadeIn":"ConfirmationPage_fadeIn__6XnYY"};